import { Component, OnInit, Output, EventEmitter, Input, HostListener } from '@angular/core';
import * as d3 from 'd3';
@Component({
    selector: 'app-forecast-chart',
    templateUrl: './forecast-chart.component.html'
})
export class ForecastChartComponent implements OnInit {
    @Input() GraphData: any;
    displayActualLegend: boolean = true;
    displayForecastLegend: boolean = true;
    constructor() { }
    viewData = [];
    barnumber = 6;
    currentPage = 1;
    totalPage: number;
    ngOnInit(): void {
    }
    ngAfterViewInit() {
        this.LoadForeCastChart(this.GraphData.chartData, this.GraphData.chartContainerName);
    }
    LoadForeCastChart(splineData, chartContainer) {
        d3.select(chartContainer).html("");
        let that = this;
        const line_stroke_width = 2;
        let scrollbar = false;
        //console.log(lineData);
        let pointGap = 30;
        var scrollWidth = (pointGap * splineData.length);
        let containerId = chartContainer;
        let containerIdwithoutHash = containerId.split('#')[1];
        let divId = '#div_' + containerIdwithoutHash;
        d3.select(containerId).html("");
        d3.select(containerId).append("div").attr('id', 'div_' + containerIdwithoutHash);
        d3.select(divId).classed('forecast', true);
        this.totalPage = Math.ceil(splineData.length / this.barnumber);
        this.viewData = splineData.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
        // set the dimensions and margins of the graph
        var svgWidth = d3.select(chartContainer).node().offsetWidth, svgHeight = 350;
        var margin = { top: 20, right: 20, bottom: 90, left: 75 };
        //d3.select(divId).style("max-height", svgHeight + "px").style("max-width", svgWidth + "px").style("overflow-x", "auto").style("overflow-y", "auto");
        // if (scrollWidth > svgWidth) {
        //     svgWidth = scrollWidth;
        //     scrollbar = true;
        // }
        var width = svgWidth - margin.left - margin.right;
        var height = svgHeight - margin.top - margin.bottom;
        let divWidth = d3.select(divId).node().offsetWidth;
        let legendWidth = divWidth - (margin.left + margin.right) + 20;
        var svg = d3.select(divId).append("svg").attr('id', 'svg_' + containerIdwithoutHash);
        if (!scrollbar) {
            svg
                .attr("preserveAspectRatio", "xMinYMin meet")
                .attr("viewBox", "0 0 " + svgWidth + " " + svgHeight);
        }
        else {
            svg
                .attr('width', scrollWidth)
                .attr('height', 300);
            //.attr('height', h)
        }
        //Create group element inside svg element to draw chart
        var chart = svg.append("g")
            .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")"
            );

        // parse the date / time
        //var parseDate = d3.timeFormat("%Y/%m/%d");
        // parse the date / time
        var parseTime = d3.timeParse("%d/%m/%Y");

        let maxDataY = d3.max(splineData, function (d) {
            return Math.max(d.ActualValue, d.ForecastedValue);
        });
        var yRange = d3.scaleLinear().range([height, 0]); //.domain([0,maxDataY]);
        var yScale = yRange.domain([0, maxDataY]);
        let yTicks = that.GenerateTicks(yRange, maxDataY);
        maxDataY = yTicks[yTicks.length - 1];
        yScale = yRange.domain([0, maxDataY]);

        //var tickYAxis = (Math.round((Math.round(Math.round(d3.max(splineData, function (d) { return Math.max(parseInt(d.ActualValue), parseInt(d.ForecastedValue)); }) / 5) / 10) * 10) / 50) * 50) + 50;

        var yAxis = chart.append('g').attr("class", "yaxis").call(d3.axisLeft(yScale)
            .tickSize(-width)
            .tickPadding(10)
            .tickFormat(d => {
                return (d > 1 || d == 0) ? `${d3.format("~s")(d)}` : d.toFixed(1);
            })
            .tickValues(that.GenerateTicks(yRange, maxDataY)));
        // .tickValues(d3.range(0, d3.max(splineData, function (d) { return Math.max(parseInt(d.ActualValue), parseInt(d.ForecastedValue)); }),
        //     tickYAxis)))
        yAxis
            .selectAll('line')
            .attr('stroke', '#e6e6e6')
        yAxis
            .select('.domain')
            .style('opacity', 0);

        var xScale = d3.scaleTime().domain(d3.extent(this.viewData, function (d) { return parseTime(d.XAxis); })).range([0, width]);

        var xAxis = chart.append('g')
            .attr("transform", "translate(0," + height + ")")
            .attr("class", "xaxis")
            .call(d3.axisBottom(xScale)
                ////.tickPadding(5)
                ////.tickSize(10, 9, 0)
                .tickFormat(d3.timeFormat("%Y-%m-%d"))
                .tickValues(this.viewData.map(function (d) { return parseTime(d.XAxis); }))
            )
        xAxis
            .selectAll('line')
            .attr('stroke', '#e6e6e6')
        xAxis
            .select('.domain')
            .style('opacity', 0);
        xAxis.selectAll("text")
            //.attr('fill', '#015b63')
            .style('font-size', '9px')
            .style('font-family', 'Graphik Regular')
            .style('white-space', 'nowrap')
            .style('cursor', 'default')
            .attr('y', '5')
            .attr('dy', '0.71em')
            .attr('x', '-10')
            .style('text-anchor', 'end')
            .attr('transform', d => 'rotate(-45)')
        //.text(d => {
        //    if (d.length > 12) {
        //        d = d.substring(0, 10) + '...';
        //    }
        //    return d;
        //})
        //.append('title')
        //.text(d => d.length > 12 ? d : null);;

        //Show the x axis labels in 45 degree and show only alternate labels in case if more than 20 x axis labels are there
        //d3.select(chartContainer).selectAll('.xaxis text')
        //    .attr("x", -12)
        //    .style("text-anchor", "end")
        //    //.attr("class", function (d, i) { if (splineData.length > 20 && i > 0 && i % 2 != 0) { d3.select(this).remove(); } })
        //    .attr("transform", "rotate(-45)")
        //    .text(d => {
        //        if (d.length > 12) {
        //            d = d.substring(0, 10) + '...';
        //        }
        //        return d;
        //    })
        //    .append('title')
        //    .text(d => d.length > 12 ? d : null);

        ////Hide the x axis ticks if alternate labels are shown when more than 20 labels
        //d3.select(chartContainer).selectAll('.xaxis ticks')
        //    .attr("class", function (d, i) { if (splineData.length > 20 && i % 2 != 0) { d3.select(this).remove(); } });

        ////Tooltip
        // const tooltip = d3.select(chartContainer)
        //     .append("div")
        //     .attr("class", "tooltip")
        //     .style("opacity", 0);

        //// define the line for actual value
        var line1 = d3.line()
            .x(function (d) {
                return xScale(parseTime(d.XAxis));
            }) // set the x values for the line generator
            .y(function (d) {
                return yScale(d.ForecastedValue);
                // set the y values for the line generator 
            })
            //.curve(d3.curveCatmullRom.alpha(1));
            .curve(d3.curveMonotoneX);
        //.curve(d3.curveCardinal); 


        //// define the line for Forecasted value
        var line2 = d3.line()
            .x(function (d) {
                if (d.ActualValue != null)
                    return xScale(parseTime(d.XAxis));
            }) // set the x values for the line generator
            .y(function (d) {
                if (d.ActualValue != null)
                    return yScale(d.ActualValue);
                // set the y values for the line generator
            })
            //.curve(d3.curveCatmullRom.alpha(1));
            .curve(d3.curveMonotoneX);
        //.curve(d3.curveCardinal); 
        chart.selectAll("rect")
            .data(this.viewData)
            .enter()
            .append("rect")
            .attr("x", (d, i) => {
                return xScale(parseTime(d.XAxis)) - 10
            })
            .attr('id', (d, i) => 'forecastrect_' + i)
            .classed('forecastrect', true)
            //.attr("y", (d, i) => yScale(d.ActualValue))
            .attr("height", height) //(d, i) => height - heightArray[i])
            .attr("width", 20)
            .style('fill', '#CCD6EB')
            .style('fill-opacity', 1)
            //.attr('stroke-width', 1)
            .attr('stroke', '#00F3FF')
            .style('opacity', 0)
            .on('mouseover', function (d, i) {
                d3.select(this).attr("r", 6);
                d3.select(this).style("stroke", '#ffffff');
                d3.select(this).style('stroke-width', 1);
                d3.select(chartContainer).selectAll('.forecastrect').style('opacity', 0);
                d3.select(chartContainer).selectAll('.forecastdot').attr('opacity', 0);
                d3.select(chartContainer).selectAll('.forecastdimond').attr('opacity', 0);
                if (that.ConvertRGB2Hex(d3.select('#actualLegend').select('line').style('stroke')).toUpperCase() == "#A260B7") {
                    d3.select('#forecastdot_' + i).style('display', 'block').attr('opacity', 0.5);
                    if (d3.select('#forecastdot_' + i).node() != undefined)
                        d3.select('#forecastdot_' + i).node().previousSibling.setAttribute('stroke', 'white')
                    if (d3.select('#forecastdot_' + i).node() != undefined)
                        d3.select('#forecastdot_' + i).node().previousSibling.setAttribute('stroke-width', 2)
                }
                if (that.ConvertRGB2Hex(d3.select('#forecastLegend').select('line').style('stroke')).toUpperCase() == "#00F3FF") {
                    d3.select('#forecastdimond_' + i).style('display', 'block').attr('opacity', 0.5);
                    if (d3.select('#forecastdimond_' + i).node() != undefined)
                        d3.select('#forecastdimond_' + i).node().previousSibling.setAttribute('stroke', 'white')
                    if (d3.select('#forecastdimond_' + i).node() != undefined)
                        d3.select('#forecastdimond_' + i).node().previousSibling.setAttribute('stroke-width', 2)
                }
                d3.select(this).style('opacity', 0.5);
                d3.select(this).style('cursor', 'pointer');
                var tooltip = svg
                    .append("g")
                    .style("cursor", "pointer")
                    .attr("class", "tooltip")
                    .style("opacity", 1)
                tooltip.append("rect")
                    .attr("width", 90)
                    .attr('height', 60)
                    .style('fill', '#FFFFFF')
                    .style('pointer-events', 'none')
                    .style('stroke', d3.select(this).style('fill'))
                    .style('stroke-width', 2)
                    .style('fill-opacity', 0.8);
                var textSvg = tooltip.append("text")
                    .attr('x', 7)
                    .attr('y', 15)
                    .style('pointer-events', 'none')
                    .style('fill', '#333333')
                    .style('font-size', '12px')
                    .style('color', '#333333');
                textSvg.append("tspan")
                    .style('font-size', '11px')
                    .style('pointer-events', 'none')
                    .style('font-family', 'Graphik Regular')
                    .style('font-weight', 'bold')
                    .text(d3.select(this).data()[0].XAxis)
                textSvg.append("tspan")
                    .attr('x', 7)
                    .attr('dy', 15)
                    .style('pointer-events', 'none')
                    .style('fill', "#A260B7")
                    .html('&#x25cf') //&#9679; //&bull;//	&#x25c6
                textSvg.append("tspan")
                    .attr('dx', 0)
                    .style('pointer-events', 'none')
                    .style('font-size', '11px')
                    .style('font-family', 'Graphik Regular')
                    .style('font-weight', 'bold')
                    .text((d3.select(this).data()[0].ActualValue == null || d3.select(this).data()[0].ActualValue == undefined) ? '' : 'Actual: ' + parseInt(d3.select(this).data()[0].ActualValue) + ' Days')
                    .style('font-weight', 'bold')
                textSvg.append("tspan")
                    .attr('x', 7)
                    .attr('dy', 15)
                    .style('pointer-events', 'none')
                    .style('fill', "#00F3FF")
                    .html('&#x25c6') //&#9679; //&bull;//	&#x25c6
                textSvg.append("tspan")
                    .attr('dx', 0)
                    .style('pointer-events', 'none')
                    .style('font-size', '11px')
                    .style('font-family', 'Graphik Regular')
                    .style('font-weight', 'bold')
                    .text((d3.select(this).data()[0].ActualValue == null || d3.select(this).data()[0].ActualValue == undefined) ? '' : 'Forecasted: ' + parseInt(d3.select(this).data()[0].ForecastedValue) + ' Days');
            })
            .on("mousemove", function (d, i) {
                d3.select(this).attr("r", 6);
                d3.select(this).style("stroke", '#ffffff');
                d3.select(this).style('stroke-width', 1);
                d3.select(chartContainer).selectAll('.forecastrect').style('opacity', 0);
                d3.select(chartContainer).selectAll('.forecastdot').attr('opacity', 0);
                d3.select(chartContainer).selectAll('.forecastdimond').attr('opacity', 0);
                if (that.ConvertRGB2Hex(d3.select('#actualLegend').select('line').style('stroke')).toUpperCase() == "#A260B7") {
                    d3.select('#forecastdot_' + i).style('display', 'block').attr('opacity', 0.5);
                    if (d3.select('#forecastdot_' + i).node() != undefined)
                        d3.select('#forecastdot_' + i).node().previousSibling.setAttribute('stroke', 'white')
                    if (d3.select('#forecastdot_' + i).node() != undefined)
                        d3.select('#forecastdot_' + i).node().previousSibling.setAttribute('stroke-width', 2)
                }
                if (that.ConvertRGB2Hex(d3.select('#forecastLegend').select('line').style('stroke')).toUpperCase() == "#00F3FF") {
                    d3.select('#forecastdimond_' + i).style('display', 'block').attr('opacity', 0.5);
                    if (d3.select('#forecastdimond_' + i).node() != undefined)
                        d3.select('#forecastdimond_' + i).node().previousSibling.setAttribute('stroke', 'white')
                    if (d3.select('#forecastdimond_' + i).node() != undefined)
                        d3.select('#forecastdimond_' + i).node().previousSibling.setAttribute('stroke-width', 2)
                }
                d3.select(this).style('opacity', 0.5);
                //d3.select(this).style('opacity', 1)
                //d3.select(this).style("fill", "#00F3FF");
                d3.select(this).style('cursor', 'pointer');
                var mousePosition = d3.mouse(this);
                var x = mousePosition[0];// + width / 2;
                var y = mousePosition[1];// + height / 2;
                var text = d3.select(this.closest('svg')).select('.tooltip text');
                //svg.selectAll('.tooltip text tspan').nodes().forEach(element => {
                //    console.log(element.getBBox().width);
                //})
                var bbox = text.node().getBBox();
                d3.select(this.closest('svg'))
                    .select('.tooltip rect')
                    .attr("width", bbox.width + 15)
                if (x - bbox.width / 2 < 0) {
                    x = bbox.width / 2;
                }
                else if (width - x - bbox.width / 2 < 0) {
                    x = width - bbox.width / 2;
                }
                if (y - bbox.height / 2 < 0) {
                    y = bbox.height * 2;
                }
                else if (height - y - bbox.height / 2 < 0) {
                    y = height - bbox.height / 2;
                }
                d3.select(this.closest('svg'))
                    .select('.tooltip')
                    .style("opacity", 1)
                    .attr('transform', `translate(${x + 10}, ${y - 20})`);
            })
            .on("mouseout", function (d, i) {
                //d3.select(this).attr("r", 3.5);
                //d3.select(this).style("stroke", '#9ce23e');
                //d3.select(this).style('stroke-width', 1);
                d3.select(chartContainer).selectAll('.forecastrect').style('opacity', 0);
                d3.select(chartContainer).selectAll('.forecastdot').attr('opacity', 0);
                d3.select(chartContainer).selectAll('.forecastdimond').attr('opacity', 0);
                if (d3.select('#forecastdot_' + i).node() != undefined)
                    d3.select('#forecastdot_' + i).node().previousSibling.setAttribute('stroke', 'none')
                if (d3.select('#forecastdot_' + i).node() != undefined)
                    d3.select('#forecastdot_' + i).node().previousSibling.setAttribute('stroke-width', 0)
                if (d3.select('#forecastdimond_' + i).node() != undefined)
                    d3.select('#forecastdimond_' + i).node().previousSibling.setAttribute('stroke', 'none')
                if (d3.select('#forecastdimond_' + i).node() != undefined)
                    d3.select('#forecastdimond_' + i).node().previousSibling.setAttribute('stroke-width', 0)

                //d3.select(this).style("fill", "#00F3FF");
                d3.select(this.closest('svg'))
                    .select('.tooltip').style('display', 'none');
                d3.select(this.closest('svg'))
                    .select(".tooltip").remove();
                // d3.select(this)//.selectAll('path')
                //     .style("opacity", 1);
            });
        ////Binds data to the line 
        chart.append('g')
            .append("path")
            .attr('id', 'actualLine')
            .datum(this.viewData)
            //.attr('class', 'line')
            .attr('d', line1)
            .attr('stroke', '#00F3FF')
            .attr("stroke-width", 2)
            .attr("fill", "none");

        ////Binds data to the line 
        chart.append('g')
            .append("path")
            .attr('id', 'forecastLine')
            .datum(this.viewData)
            //.attr('class', 'line')
            .attr('d', line2)
            .attr('stroke', '#A260B7')
            .attr("stroke-width", 2)
            .attr("fill", "none");

        //append dots for each data to hover
        var dots = chart
            .selectAll(".dot")
            .data(this.viewData)
            .enter()
            .append('g')
        dots.append("circle") // Uses the enter().append() method
            .attr("class", "dot") // Assign a class for styling
            .attr('fill', '#A260B7')
            .attr('opacity', function (d) { return d.ActualValue == null ? '0' : '1' })
            //.classed('forecastdot', true)
            .attr("cx", function (d) { if (d.ActualValue != null) { return xScale(parseTime(d.XAxis)) } })
            .attr("cy", function (d) { if (d.ActualValue != null) { return yScale(d.ActualValue) } })
            .attr("r", 4)
        dots.append("circle") // Uses the enter().append() method
            .attr("class", "dot") // Assign a class for styling
            .attr('fill', '#A260B7')
            .attr('opacity', function (d) {
                return d.ActualValue == null ? '0' : '0.25'
            })
            .attr('id', (d, i) => {
                if (d.ActualValue != null) {
                    return 'forecastdot_' + i
                }
            })
            .classed('forecastdot', true)
            .attr("cx", function (d) { if (d.ActualValue != null) { return xScale(parseTime(d.XAxis)) } })
            .attr("cy", function (d) { if (d.ActualValue != null) { return yScale(d.ActualValue) } })
            .attr("r", 10)
            .style('display', 'none')
        //append dimonds for each data to hover
        var dimonds = chart
            .selectAll(".dimond")
            .data(this.viewData)
            .enter()
            .append('g')
        dimonds.append("path") // Uses the enter().append() method
            .attr('fill', '#00F3FF')
            .attr("class", "dimond") // Assign a class for styling
            .attr('opacity', '1')
            //.classed('forecastdimond', true)
            //.attr("cx", function (d) { return xScale(parseTime(d.XAxis)) })
            //.attr("cy", function (d) { return yScale(d.ActualValue) })
            //.attr("r", 3.5)
            .attr("d", d3.symbol().type(d3.symbolDiamond).size(50))
            .attr("transform", function (d) {
                return "translate(" + xScale(parseTime(d.XAxis)) +
                    "," + yScale(d.ForecastedValue) + ")";
            })
        dimonds.append("path") // Uses the enter().append() method
            .attr('fill', '#00F3FF')
            .attr("class", "dimond") // Assign a class for styling
            .attr('id', (d, i) => 'forecastdimond_' + i)
            .attr('opacity', '1')
            .classed('forecastdimond', true)
            //.attr("cx", function (d) { return xScale(parseTime(d.XAxis)) })
            //.attr("cy", function (d) { return yScale(d.ActualValue) })
            //.attr("r", 3.5)
            .attr("d", d3.symbol().type(d3.symbolDiamond).size(200))
            .attr("transform", function (d) {
                return "translate(" + xScale(parseTime(d.XAxis)) +
                    "," + yScale(d.ForecastedValue) + ")";
            })
            .style('display', 'none')


        //chart.selectAll(".diamond")
        //    .enter().append("path")
        //    .attr("d", d3.svg.symbol())
        //    .size()
        //    .type("diamond")
        //    //.attr("transform", "translate(250, 150)")
        //    .style("fill", "black");

        // trying to draw a diamond here 
        //.attr("d", "M 50 0 100 100 50 200 0 100 Z")

        //Y Axis legend
        svg.append('text')
            .attr('x', -(height / 2))
            //.attr('y', (margin.left / 3))
            .attr('y', 10)
            .attr("dy", "1em")
            .attr("font-family", "Graphik Regular")
            .attr('transform', 'rotate(-90)')
            .style('fill', '#015b63')
            .style('font-size', '12px')
            .style('font-weight', 'bold')
            .attr('text-anchor', 'middle')
            .text('TicketCount');
        let legendsSVG;
        if (scrollbar) {
            d3.select(containerId).append('div').attr('id', 'divLegend_' + containerIdwithoutHash).attr('width', divWidth).style('height', '12.6px').append('svg').attr('id', 'svgLegend_' + containerIdwithoutHash).attr('width', divWidth).attr('height', 10);
            legendsSVG = d3.select('#svgLegend_' + containerIdwithoutHash);
            //X Axis legend
            var actualLegend = legendsSVG.append("g")
                .attr("id", "actualLegend")
                .style('cursor', 'pointer')
                .attr("transform",
                    "translate(" + (-margin.right - margin.left) + "," + 0 + ")")
                .on('click', () => {
                    if (that.ConvertRGB2Hex(d3.select('#actualLegend').select('line').style('stroke')).toUpperCase() == "#A260B7") {
                        dots.selectAll(".dot").style('display', 'none');
                        d3.select('#forecastLine').style('display', 'none');
                        d3.select('#actualLegend').select('line').style('stroke', '#cccccc');
                        d3.select('#actualLegend').select('rect').style('fill', '#cccccc');
                    }
                    else {
                        dots.selectAll(".dot").style('display', 'block');
                        d3.select('#forecastLine').style('display', 'block');
                        d3.select('#actualLegend').select('line').style('stroke', '#A260B7');
                        d3.select('#actualLegend').select('rect').style('fill', '#A260B7');
                    }
                });

            actualLegend.append("line")
                .attr("x1", (divWidth / 2) - 25)
                .attr("y1", 20)
                .attr("x2", (divWidth / 2) - 7)
                .attr("y2", 20)
                .attr("fill", "none")
                .attr("stroke", "#A260B7")
                .attr("stroke-width", 2);

            actualLegend.append("rect")
                .attr("x", (divWidth / 2) - 20)
                .attr("y", 16)
                .attr('height', 8)
                .attr('width', 8)
                .attr('rx', 4)
                .attr('ry', 4)
                .style('fill', '#A260B7')
                //.style('cursor', 'default')
                .style('top', margin.top)
                .attr('text-anchor', 'end');

            actualLegend.append('text')
                .attr('x', (divWidth / 2))
                .attr('y', 24)
                .style('fill', '#015b63')
                .style('cursor', 'pointer')
                .style('font-size', '12px')
                .style('font-weight', 'bold')
                .attr('text-anchor', 'start')
                .text('Actual');

            var forecastLegend = legendsSVG.append("g")
                .attr("id", "forecastLegend")
                .style('cursor', 'pointer')
                .attr("transform",
                    "translate(" + (margin.right) + "," + 0 + ")")
                .on('click', () => {
                    if (that.ConvertRGB2Hex(d3.select('#forecastLegend').select('line').style('stroke')).toUpperCase() == "#00F3FF") {
                        dimonds.selectAll(".dimond").style('display', 'none');
                        d3.select('#actualLine').style('display', 'none');
                        d3.select('#forecastLegend').select('line').style('stroke', '#cccccc');
                        d3.select('#forecastLegend').select('path').style('fill', '#cccccc');
                    }
                    else {
                        dimonds.selectAll(".dimond").style('display', 'block');
                        d3.select('#actualLine').style('display', 'block');
                        d3.select('#forecastLegend').select('line').style('stroke', '#00F3FF');
                        d3.select('#forecastLegend').select('path').style('fill', '#00F3FF');
                    }
                });

            forecastLegend.append("line")
                .attr("x1", (divWidth / 2) - 25)
                .attr("y1", 20)
                .attr("x2", (divWidth / 2) - 7)
                .attr("y2", 20)
                .attr("stroke", "#00F3FF")
                .attr("stroke-width", 2);

            forecastLegend.append("path")
                .attr("d", function (d) { return d3.symbol().type(d3.symbolDiamond).size("30")(); })
                .attr("transform", "translate(" + ((divWidth / 2) - 15) + ", " + (20) + ")")
                .style('fill', '#00F3FF')
                //.style('cursor', 'default')
                .style('top', margin.top)
                .attr('text-anchor', 'end');

            forecastLegend.append('text')
                .attr('x', (divWidth / 2))
                .attr('y', 24)
                .style('fill', '#015b63')
                .style('cursor', 'pointer')
                .style('font-size', '12px')
                .style('font-weight', 'bold')
                .attr('text-anchor', 'start')
                .text('Forecasted');
        }
        else {
            legendsSVG = svg;
            //X Axis legend
            var actualLegend = legendsSVG.append("g")
                .attr("id", "actualLegend")
                .style('cursor', 'pointer')
                .attr("transform",
                    "translate(" + (-margin.right - margin.left) + "," + 0 + ")")
                .on('click', () => {
                    that.displayActualLegend = false;
                    that.ToggleActualLegend(dots);
                });

            actualLegend.append("line")
                .attr("x1", (svgWidth / 2) - 25)
                .attr("y1", svgHeight - margin.top - 5)
                .attr("x2", (svgWidth / 2) - 7)
                .attr("y2", svgHeight - margin.top - 5)
                .attr("fill", "none")
                .attr("stroke", "#A260B7")
                .attr("stroke-width", 2);

            actualLegend.append("rect")
                .attr("x", (svgWidth / 2) - 20)
                .attr("y", svgHeight - margin.top - 9)
                .attr('height', 8)
                .attr('width', 8)
                .attr('rx', 4)
                .attr('ry', 4)
                .style('fill', '#A260B7')
                //.style('cursor', 'default')
                .style('top', margin.top)
                .attr('text-anchor', 'end');

            actualLegend.append('text')
                .attr('x', (svgWidth / 2))
                .attr('y', svgHeight - margin.top)
                .style('fill', '#015b63')
                .style('cursor', 'pointer')
                .style('font-size', '12px')
                .style('font-weight', 'bold')
                .attr('text-anchor', 'start')
                .text('Actual');

            var forecastLegend = legendsSVG.append("g")
                .attr("id", "forecastLegend")
                .style('cursor', 'pointer')
                .attr("transform",
                    "translate(" + (margin.right) + "," + 0 + ")")
                .on('click', () => {
                    that.displayForecastLegend = false;
                    that.ToggleForecastLegend(dimonds);
                });

            forecastLegend.append("line")
                .attr("x1", (svgWidth / 2) - 25)
                .attr("y1", svgHeight - margin.top - 5)
                .attr("x2", (svgWidth / 2) - 7)
                .attr("y2", svgHeight - margin.top - 5)
                .attr("stroke", "#00F3FF")
                .attr("stroke-width", 2);

            forecastLegend.append("path")
                .attr("d", function (d) { return d3.symbol().type(d3.symbolDiamond).size("30")(); })
                .attr("transform", "translate(" + ((svgWidth / 2) - 15) + ", " + (svgHeight - margin.top - 5) + ")")
                .style('fill', '#00F3FF')
                //.style('cursor', 'default')
                .style('top', margin.top)
                .attr('text-anchor', 'end');

            forecastLegend.append('text')
                .attr('x', (svgWidth / 2))
                .attr('y', svgHeight - margin.top)
                .style('fill', '#015b63')
                .style('cursor', 'pointer')
                .style('font-size', '12px')
                .style('font-weight', 'bold')
                .attr('text-anchor', 'start')
                .text('Forecasted');
            //Pagination
            if (this.totalPage > 1) {
                svg.append("path")
                    .attr("d", "M3.875,3.095,6.8.163a.551.551,0,0,1,.782,0,.558.558,0,0,1,0,.784L4.267,4.269a.553.553,0,0,1-.763.016L.161.949A.554.554,0,0,1,.943.165Z")
                    .attr('transform', "translate(" + (margin.left - 30) + ", " + (svgHeight - margin.bottom + 9) + ") rotate(90)")     //19 (Because tickpadding=8 + margin from insertLineBreak=10 + 1(MagicNumber))
                    .attr('class', 'leftTriangle')
                    .attr('fill', '#000')
                    .attr('stroke', '#000')
                    .attr('stroke-width', 2)
                    .attr("opacity", 0.7)
                    .attr('cursor', 'pointer')
                    .on('click', function (d) {
                        if (that.currentPage != 1) {
                            that.currentPage--;
                            that.prevPage();
                        }
                    })
                svg.append("path")
                    .attr("d", "M3.875,1.335,6.8,4.267a.551.551,0,0,0,.782,0,.558.558,0,0,0,0-.784L4.267.161A.553.553,0,0,0,3.5.145L.161,3.481a.554.554,0,0,0,.782.784Z")
                    .attr('transform', "translate(" + (svgWidth - margin.right + 14) + ", " + (svgHeight - margin.bottom + 9) + ") rotate(90)")
                    .attr('class', 'rightTriangle')
                    .attr('fill', '#000')
                    .attr('stroke', '#000')
                    .attr('stroke-width', 2)
                    .attr("opacity", 0.7)
                    .style('cursor', 'pointer')
                    .on('click', function (d) {
                        if (that.currentPage < that.totalPage) {
                            that.currentPage++;
                            that.nextPage();
                        }
                    })

                if (that.currentPage == 1) {
                    svg.select(".leftTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
                }
                if (that.currentPage == that.totalPage) {
                    svg.select(".rightTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
                }
            }
            this.ToggleActualLegend(dots);
            this.ToggleForecastLegend(dimonds);
            d3.select(chartContainer).selectAll('.forecastrect').style('opacity', 0);
            d3.select(chartContainer).selectAll('.forecastdot').attr('opacity', 0);
            d3.select(chartContainer).selectAll('.forecastdimond').attr('opacity', 0);
        }
    }
    ConvertRGB2Hex(rgb) {
        rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        return (rgb && rgb.length === 4) ? "#" +
            ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
    }
    GenerateTicks(axisRange, maxData) {
        let tickArray = axisRange.ticks(4);
        if (tickArray[tickArray.length - 1] < maxData) {
            let diff = (tickArray[tickArray.length - 1]) - (tickArray[tickArray.length - 2]); // Add the difference to create new tick
            tickArray.push(tickArray[tickArray.length - 1] + diff);
        }
        return tickArray;
    }
    /*generic way */
    nextPage() {
        this.LoadForeCastChart(this.GraphData.chartData, this.GraphData.chartContainerName);
    }

    prevPage() {
        this.LoadForeCastChart(this.GraphData.chartData, this.GraphData.chartContainerName);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.LoadForeCastChart(this.GraphData.chartData, this.GraphData.chartContainerName);
    }
    ToggleActualLegend(dots) {
        if (this.ConvertRGB2Hex(d3.select('#actualLegend').select('line').style('stroke')).toUpperCase() == "#A260B7" && this.displayActualLegend == false) {
            dots.selectAll(".dot").style('display', 'none');
            d3.select('#forecastLine').style('display', 'none');
            d3.select('#actualLegend').select('line').style('stroke', '#cccccc');
            d3.select('#actualLegend').select('rect').style('fill', '#cccccc');
            this.displayActualLegend = false;
        }
        else {
            dots.selectAll(".dot").style('display', 'block');
            d3.select('#forecastLine').style('display', 'block');
            d3.select('#actualLegend').select('line').style('stroke', '#A260B7');
            d3.select('#actualLegend').select('rect').style('fill', '#A260B7');
            this.displayActualLegend = true;
        }
    }

    ToggleForecastLegend(dimonds) {
        if (this.ConvertRGB2Hex(d3.select('#forecastLegend').select('line').style('stroke')).toUpperCase() == "#00F3FF" && this.displayForecastLegend == false) {
            dimonds.selectAll(".dimond").style('display', 'none');
            d3.select('#actualLine').style('display', 'none');
            d3.select('#forecastLegend').select('line').style('stroke', '#cccccc');
            d3.select('#forecastLegend').select('path').style('fill', '#cccccc');
            this.displayForecastLegend = false;
        }
        else {
            dimonds.selectAll(".dimond").style('display', 'block');
            d3.select('#actualLine').style('display', 'block');
            d3.select('#forecastLegend').select('line').style('stroke', '#00F3FF');
            d3.select('#forecastLegend').select('path').style('fill', '#00F3FF');
            this.displayForecastLegend = true;
        }
    }
}
